export function FacebookIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>Facebook&apos;s logo</desc>
      <path
        d="M4.00016 0.5C1.98698 0.5 0.333496 2.15348 0.333496 4.16667V20.8333C0.333496 22.8465 1.98698 24.5 4.00016 24.5H20.6668C22.68 24.5 24.3335 22.8465 24.3335 20.8333V4.16667C24.3335 2.15348 22.68 0.5 20.6668 0.5H4.00016ZM4.00016 2.5H20.6668C21.599 2.5 22.3335 3.23452 22.3335 4.16667V20.8333C22.3335 21.7655 21.599 22.5 20.6668 22.5H16.3335V15.8333H18.7502C19.0862 15.8333 19.3703 15.582 19.4116 15.2487L19.6616 13.2487C19.6856 13.0594 19.6255 12.8693 19.4989 12.7253C19.3729 12.5819 19.1915 12.5 19.0002 12.5H16.3335V10.1667C16.3335 9.43133 16.9315 8.83333 17.6668 8.83333H19.0002C19.3682 8.83333 19.6668 8.53533 19.6668 8.16667V5.91667C19.6668 5.57133 19.4034 5.28327 19.0601 5.2526C19.0207 5.24927 18.0802 5.16667 16.8895 5.16667C13.9515 5.16667 12.3335 6.91079 12.3335 10.0781V12.5H9.66683C9.29883 12.5 9.00016 12.798 9.00016 13.1667V15.1667C9.00016 15.5353 9.29883 15.8333 9.66683 15.8333H12.3335V22.5H4.00016C3.06801 22.5 2.3335 21.7655 2.3335 20.8333V4.16667C2.3335 3.23452 3.06801 2.5 4.00016 2.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FacebookIcon
